import { render, staticRenderFns } from "./SecondaryCaseDialog.vue?vue&type=template&id=180a7e9f&scoped=true"
import script from "./SecondaryCaseDialog.vue?vue&type=script&lang=js"
export * from "./SecondaryCaseDialog.vue?vue&type=script&lang=js"
import style0 from "./SecondaryCaseDialog.vue?vue&type=style&index=0&id=180a7e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a7e9f",
  null
  
)

export default component.exports